import { related, sourceIds } from './trophies__karaoke-answers.mdx';

export { sourceIds, related };
export const quickAnswer =
  '九次选择依次为：右 → 左 → 右 → 上 → 左 → 下 → 右 → 上 → 右。';

## 九次卡拉 OK 选择

1. 右
2. 左
3. 右
4. 上
5. 左
6. 下
7. 右
8. 上
9. 右

## 成就尝试怎么进行

在 The Party Won’t Stop 中使用卡拉 OK 机器，按方向匹配每次选择。对应尝试要求救下所有人，本文不复制歌词。

## 选错怎么办

错误选择可能使本次尝试失效。先停止继续推进，检查现有存档。

## 能不能重试

已发布流程建议读取错误发生前的存档。必须确认存档时间足够早；结束或覆盖存档后的尝试不能保证恢复。开始前保留较早存档。
